import { Injectable } from '@angular/core';
import { AccountGroupApiService, ProjectionFilter } from '@galaxy/account-group';
import { ReplaySubject, map, of, switchMap } from 'rxjs';

@Injectable()
export class AccountFilterService {
  private readonly selectedAccountGroupId$$ = new ReplaySubject<string>(1);
  readonly selectedAccountGroupId$ = this.selectedAccountGroupId$$.asObservable();
  readonly selectedAccountGroupName$ = this.selectedAccountGroupId$.pipe(
    switchMap((accountGroupId) => {
      if (accountGroupId === '') return of(null);
      return this.accountGroupService.get(accountGroupId, new ProjectionFilter({ napData: true }));
    }),
    map((accountGroup) => accountGroup?.napData?.companyName ?? ''),
  );

  constructor(private accountGroupService: AccountGroupApiService) {}

  setAccountGroupId(accountGroupId: string): void {
    this.selectedAccountGroupId$$.next(accountGroupId);
  }

  clearAccountGroupFilter(): void {
    this.setAccountGroupId('');
  }
}
